import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";
import React from "react";

export const CircularProgressSize = {
  extraSmall: 16,
  small: 24,
  medium: 36,
  large: 48,
};

const CircularProgressBar = ({
  size = CircularProgressSize.medium,
  color = "red",
}) => {
  return (
    <Box
      className="mx-auto"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        size={size}
        sx={{
          color: color,
        }}
      />
    </Box>
  );
};

CircularProgressBar.propTypes = {
  size: PropTypes.oneOf([
    CircularProgressSize.extraSmall,
    CircularProgressSize.small,
    CircularProgressSize.medium,
    CircularProgressSize.large,
  ]),
  color: PropTypes.string,
};

export default CircularProgressBar;
